import { render, staticRenderFns } from "./SystemSettingsOthers.vue?vue&type=template&id=6dbb412c"
import script from "./SystemSettingsOthers.vue?vue&type=script&lang=js"
export * from "./SystemSettingsOthers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports